module.exports = __webpack_public_path__ + "img/terminal-box-fill.866e6dec.svg";